<template>
  <div style="margin-bottom: 10px; text-align: left">
    <el-button-group>
      <el-button type="primary" icon="el-icon-document" v-if="tableType == '待处理'" :disabled="!isSelect"
        @click="createTask">生成拣货任务 {{ selectedRows.length?`(${selectedRows.length})`:"" }}
      </el-button>
    </el-button-group>

  </div>
</template>

<script>

import { regularizationCreateTask, regularizationDetail, regularizationPage } from "@/apis/abnormal";
export default {
  name: "InterBtnBox",
  components: {},
  data() {
    return {

    };
  },
  props: {
    selectedRows: {
      type: Array,
      required: true,
    },
    tableType: {
      type: String,
    }
  },
  computed: {
    isSelect: function () {
      return !!this.selectedRows && !!this.selectedRows.length;
    },
  },
  methods: {
    createTask() {
      let params = this.selectedRows.map(item => { return item.pkgCode })
      regularizationCreateTask(params).then(res => {
        if (res.code == 0) {
          this.$message.success("操作成功");
          this.$emit("queryHandler",{});
        }
      })
    }
  },
};
</script>

<style scoped>

</style>
